import { keyframes, css } from '@emotion/react'
import styled from '@emotion/styled'

const aiHighlightAnimation = keyframes`
  0% {
    background-color: rgba(139, 92, 246, 0.1);
    box-shadow: 0 0 0 0 rgba(139, 92, 246, 0.4);
  }
  50% {
    background-color: rgba(139, 92, 246, 0.15);
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.2);
  }
  100% {
    background-color: transparent;
    box-shadow: 0 0 0 0 rgba(139, 92, 246, 0);
  }
`

export const AIHighlightContainer = styled.div<{ isHighlighted?: boolean }>`
  position: relative;
  transition: all 0.3s ease;

  ${props => props.isHighlighted && css`
    animation: ${aiHighlightAnimation} 2s ease-in-out;

    &::before {
      content: 'Gerado por IA ✨';
      position: absolute;
      top: -25px;
      right: 0;
      background: linear-gradient(90deg, #8b5cf6, #a78bfa);
      color: white;
      padding: 4px 12px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
      animation: fadeInOut 3s ease-in-out;
      z-index: 10;
      white-space: nowrap;
    }
  `}

  @keyframes fadeInOut {
    0% {
      opacity: 0;
      transform: translateY(-10px);
    }
    20% {
      opacity: 1;
      transform: translateY(0);
    }
    80% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
`

export const scrollToElement = (elementId: string, offset: number = 100) => {
  setTimeout(() => {
    const element = document.getElementById(elementId)
    if (element) {
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }, 100)
}